<template>
  <div>
    <NuxtLayout name="default">
      <HeroStandardApollo
        :bg-image-source="$page?.aboutRankings?.heroImage!"
        :title="$page?.aboutRankings.heroTitle!"
        title-size="large"
        :show-title-highlight="true"
        :show-text="true"
        :text="$page?.aboutRankings.heroSubtitle!"
        text-font-weight="bold"
        text-size="xl"
        :show-text-highlight="true"
      ></HeroStandardApollo>

      <!-- Is ASU Online good school section -->
      <section class="py-space-lg pb-lg-0 pt-lg-space-xxl bg-light-2">
        <div class="container px-space-sm px-md-0">
          <div class="row">
            <div
              class="col-12 offset-lg-1 col-lg-10 d-flex flex-column flex-lg-row p-space-md pt-md-space-xl pl-md-space-xl asu-online-good-bg"
              :style="getBgImage($page?.aboutRankings.asuoGoodBgImage!)"
            >
              <div class="is-asu-online-good-body">
                <h2 class="h2-medium mb-space-sm">
                  {{ $page?.aboutRankings.asuoGoodTitle }}
                </h2>
                <div
                  class="fs-medium mb-space-lg"
                  v-html="$page?.aboutRankings.asuoGoodDescription"
                ></div>

                <div class="my-space-xs pe-md-space-xs">
                  <div
                    v-for="(eachItem, index) in $page?.aboutRankings
                      .asuoGoodStatItems"
                    :key="index"
                    class="mb-space-md d-flex flex-column flex-md-row flex-none"
                  >
                    <h3
                      class="mb-space-xs h3-xl bg-secondary py-space-xxs px-space-xs me-space-xs d-inline-block good-shool-badge"
                    >
                      {{ eachItem?.title }}
                    </h3>
                    <p class="fw-bold fs-xl mb-0 wrap-text">
                      {{ eachItem?.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block is-asu-online-good-image">
                <img
                  :alt="$page?.aboutRankings.asuoGoodTitle!"
                  class="asu-online-like-img ms-space-lg"
                  :src="$page?.aboutRankings.asuoGoodImage!"
                  height="470"
                />
              </div>
            </div>
          </div>
          <div class="row d-block d-lg-none">
            <div class="col-12">
              <div class="text-center">
                <img
                  :alt="$page?.aboutRankings.asuoGoodTitle!"
                  class="asu-online-like-img"
                  height="410"
                  :src="$page?.aboutRankings.asuoGoodImage!"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Recent university section -->
      <section
        class="py-space-lg py-lg-space-xxl bg-light-2 asu-responsibility"
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2 class="h2-medium mb-space-sm text-center">
                {{ $page?.aboutRankings.recentTitle }}
              </h2>
              <div class="mb-space-md text-center">
                <h3
                  class="h3-small text-dark-3 d-inline-block bg-secondary py-space-xxs px-space-xxs px-md-space-xs fw-bold"
                >
                  {{ $page?.aboutRankings.recentSubtitle }}
                </h3>
              </div>
            </div>
          </div>

          <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
            <div
              class="col mb-space-sm mb-md-space-md mb-lg-0 card-icon-wrap"
              v-for="(card, index) in $page?.aboutRankings.recentCards"
              :key="index"
            >
              <CardImageTile
                class="h-100"
                :bg-image-src="card?.image!"
                :display-gradient="true"
                :title="card?.title!"
                title-variant="white"
                :text="card?.text!"
                text-size="large"
                :display-cta="true"
                :cta-link="card?.link?.uri!"
                :cta-link-target="formatLinkTarget(card?.link?.target!)"
                :cta-text="card?.link?.text!"
                :clickable-card="true"
                @cardClick="
                  handleCardImageClick(
                    $page?.aboutRankings.recentTitle!,
                    card?.title!,
                    card?.link?.uri!
                  )
                "
                @ctaClick="
                  handleCardImageCtaClick(
                    $page?.aboutRankings.recentTitle!,
                    card?.title!,
                    card?.link?.uri!
                  )
                "
              >
              </CardImageTile>
            </div>
          </div>
        </div>
      </section>

      <!-- Recognition and awards section -->

      <SectionParallaxAtlas
        container-bg-variant="white"
        :bg-image-source="$page?.aboutRankings.recognitionImage!"
        :show-label="false"
        :title="$page?.aboutRankings.recognitionTitle!"
      >
        <template #text>
          <div
            v-html="$page?.aboutRankings.recognitionDescription"
            class="mb-space-sm mb-md-space-lg mb-lg-space-xl"
          ></div>
        </template>

        <!-- cards -->
        <template #body>
          <CollapseItem
            v-for="(eachItem, index) in $page?.aboutRankings.recognitionCards"
            :key="index"
            :collapse-id="'cp' + eachItem?.id"
            :display-number="false"
            :title="eachItem?.title!"
            title-size="large"
            class="mb-space-sm"
            border-variant="light-4"
            accordion-group-id="rankings-first-accordion"
            @collapseShown="
              handleCollapseEvent(
                'open',
                $page?.aboutRankings.recognitionTitle!,
                eachItem?.title!
              )
            "
            @collapseHidden="
              handleCollapseEvent(
                'close',
                $page?.aboutRankings.recognitionTitle!,
                eachItem?.title!
              )
            "
          >
            <template #title-slot>
              <div class="d-flex flex-column align-items-start">
                <div
                  class="bg-secondary fs-large d-inline-block title-slot mb-space-xxs text-dark-3 fw-bold"
                >
                  <span>{{ eachItem?.label }}</span>
                </div>
                <h3 class="h3-large text-dark-3">{{ eachItem?.title! }}</h3>
              </div>
            </template>

            <div v-html="eachItem?.description"></div>
          </CollapseItem>
        </template>
      </SectionParallaxAtlas>

      <!-- Impact Rankings section -->
      <SectionCardApollo
        :title="$page?.aboutRankings.globalTitle!"
        bg-image-lazy
        title-level="h2"
        :bg-image-source="$page?.aboutRankings.globalImage!"
        class="global-rankings-section mb-0 mb-md-space-lg mb-lg-space-xxl dark-3"
      >
        <template #text>
          <div v-html="$page?.aboutRankings.globalShortDescription"></div>
        </template>
        <template #body>
          <div
            class="text-light-2 globalDescription"
            v-html="$page?.aboutRankings.globalLongDescription"
          ></div>
        </template>
      </SectionCardApollo>

      <!-- Leading research university section -->
      <SectionParallaxAtlas
        container-bg-variant="white"
        :bg-image-source="$page?.aboutRankings.leadingImage!"
        :show-label="false"
        :title="$page?.aboutRankings.leadingTitle!"
      >
        <template #text>
          <div class="ms-space-xxs mb-space-xs mb-md-space-sm mb-space-sm">
            <div
              class="fw-bold d-inline px-space-xxs py-space-xxs bg-secondary highlight-text"
              v-html="$page?.aboutRankings.leadingSubtitle"
            ></div>
          </div>
          <div
            class="mb-space-xl"
            v-html="$page?.aboutRankings.leadingDescription"
          ></div>
        </template>

        <!-- cards -->
        <template #body>
          <transition name="slide-fade" tag="div" mode="out-in">
            <div v-bind:key="currentSlide" class="mb-space-sm mb-lg-space-md">
              <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
                <div
                  v-for="(eachItem, index) in paginatedCards"
                  :key="index"
                  class="col mb-space-md mb-md-space-lg pe-space-lg"
                >
                  <h3 class="mb-space-xs h3-large">
                    <div class="bg-secondary p-space-xxs d-inline-block">
                      {{ eachItem?.title }}
                    </div>
                  </h3>
                  <div
                    class="mb-space-xxs mb-md-space-xs mb-lg-space-sm fw-bold"
                  >
                    {{ eachItem?.text }}
                  </div>
                  <div class="fs-xs">{{ eachItem?.subText }}</div>
                </div>
              </div>
            </div>
          </transition>
          <div
            v-if="rankingsItemsList?.length! > perPage"
            class="row text-center"
          >
            <div class="d-none d-md-block col-12">
              <div class="mb-space-sm mb-lg-space-md">
                <button
                  class="carousel-indicator"
                  v-for="(item, index) in totalPages"
                  :class="{
                    active: currentSlide === item,
                    'me-space-xxs': !isLastIndex(totalPages, index),
                  }"
                  :key="index"
                  @click="handleIndicatorClick(item)"
                  aria-label="carousel indicator"
                ></button>
              </div>
            </div>
            <div class="col-12">
              <div class="d-inline-flex">
                <div
                  class="carousel-control me-md-space-sm"
                  :class="{ disable: currentSlide === 1 }"
                  @click="showPreviousSlide"
                >
                  <img alt="left-chevron" :src="Left" />
                </div>
                <div class="fs-xs d-md-none mx-space-xxs my-auto">
                  {{ currentSlide }} of {{ totalPages }}
                </div>
                <div
                  class="carousel-control"
                  :class="{ disable: currentSlide === totalPages }"
                  @click="showNextSlide"
                >
                  <img alt="right-chevron" :src="Right" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </SectionParallaxAtlas>

      <!-- FAQ section -->
      <section
        class="px-space-xs px-md-0 py-space-md py-md-space-lg py-lg-space-xxl section-accolades-bg"
        :style="getBgImage($page?.aboutRankings.faqImage!)"
      >
        <div class="container">
          <div class="row">
            <div
              class="bg-light-2 offset-lg-1 col-12 col-lg-10 pt-space-md pb-space-xs px-space-xs px-md-space-md p-lg-space-xl"
            >
              <h2 class="h2-medium mb-space-sm">
                {{ $page?.aboutRankings.faqTitle }}
              </h2>
              <div class="hr-line bg-secondary mb-space-md"></div>
              <RdsAccordion>
                <CollapseItem
                  v-for="(eachFaqItem, i) in $page?.aboutRankings.faqItems"
                  :key="'faqItem' + i"
                  :collapse-id="'faqItem' + i"
                  :display-number="false"
                  :title="eachFaqItem?.title!"
                  title-size="medium"
                  class="mb-space-xs mb-md-space-sm bg-white"
                  border-variant="light-4"
                  accordion-group-id="rankings-second-accordion"
                  @collapseShown="
                    handleCollapseEvent(
                      'open',
                      $page?.aboutRankings.faqTitle!,
                      eachFaqItem?.title!
                    )
                  "
                  @collapseHidden="
                    handleCollapseEvent(
                      'close',
                      $page?.aboutRankings.faqTitle!,
                      eachFaqItem?.title!
                    )
                  "
                >
                  <div>
                    <div v-html="eachFaqItem?.description"></div>
                  </div>
                </CollapseItem>
              </RdsAccordion>
            </div>
          </div>
        </div>
      </section>

      <!-- section-rfi-multi-step -->
      <SectionRfiMultiStep :bg-image="RfiBgImage"></SectionRfiMultiStep>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { analyticsComposable } from "@rds-vue-ui/analytics-gs-composable";
import { CardImageTile } from "@rds-vue-ui/card-image-tile";
import { CollapseItem } from "@rds-vue-ui/collapse-item";
import HeroStandardApollo from "@rds-vue-ui/hero-standard-apollo/HeroStandardApollo.vue";
import { RdsAccordion } from "@rds-vue-ui/rds-accordion";
import { SectionCardApollo } from "@rds-vue-ui/section-card-apollo";
import { SectionParallaxAtlas } from "@rds-vue-ui/section-parallax-atlas";
import Left from "~/assets/img/left.svg?inline";
import RfiBgImage from "~/assets/img/rfi-bg-overlay.png";
import Right from "~/assets/img/right.svg?inline";
import SectionRfiMultiStep from "~/components/rfi/SectionRfiMultiStep.vue";
import { useUtilityService } from "~/composables/useUtilityService";
import {
  AboutRankings,
  ParagraphStatApollo,
} from "~/server/resolvers/resolvers-types";

definePageMeta({
  layout: false,
  __dangerouslyDisableSanitizersByTagID: {
    "ldjson-schema": ["innerHTML"],
  },
});

const config = useRuntimeConfig();

const UtilityService = useUtilityService();

interface RankingsResponse {
  aboutRankings: AboutRankings;
}

const $page = await usePageQuery<RankingsResponse>(
  `#graphql
      query aboutRankings($rankingsId: ID!){
        aboutRankings(id:$rankingsId) {
          metaTitle
          metaDescription
          detailPage
          heroTitle
          heroSubtitle
          heroImage
          asuoGoodTitle
          asuoGoodDescription
          asuoGoodBgImage
          asuoGoodImage
          asuoGoodStatItems {
            id
            title
            text
          }
          recentTitle
          recentSubtitle
          recentCards {
            title
            image
            imageAlt
            text
            link {
              text
              uri
              target
            }
          }
          recognitionTitle
          recognitionDescription
          recognitionImage
          recognitionCards {
            id
            title
            label
            description
          }
          globalTitle
          globalShortDescription
          globalLongDescription
          globalImage
          leadingTitle
          leadingSubtitle
          leadingDescription
          leadingImage
          leadingRankings {
            title
            text
            subText
          }
          faqTitle
          faqImage
          faqItems {
            title
            description
          }
        }
      }`,
  {
    rankingsId: "7d7613ee-7aab-48e0-8947-78b485e0b779",
  },
  {
    key: "rankings-page",
  }
);

const currentSlide = ref(1);
const paginatedCards = ref<ParagraphStatApollo[] | undefined>([]);
const perPage = 6;
const rankingsItemsList = ref<ParagraphStatApollo[] | undefined>([]);

useHead({
  title: $page?.aboutRankings.metaTitle,
  meta: [
    { name: "Title", content: $page?.aboutRankings.metaTitle },
    {
      name: "Description",
      content: $page?.aboutRankings.metaDescription,
    },
  ],
  link: [
    {
      rel: "canonical",
      href: UtilityService.formatCanonicalUrl(
        `${config.public.siteUrl}${$page?.aboutRankings.detailPage}`
      ),
    },
  ],
  script: [
    useSchemaService().generateAboutUsRankingsSchema($page?.aboutRankings),
  ],
});

const getBgImage = (img: string) => {
  return { "background-image": `url('${img}')` };
};

const formatLinkTarget = (target: string) => {
  return UtilityService.formatLinkTarget(target);
};

const handleCardImageClick = (section: string, text: string, url: string) => {
  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    section.toLowerCase(),
    text.toLowerCase(),
    "hover card"
  );
  if (process.client) {
    navigateTo(url, {
      open: {
        target: "_self",
      },
    });
  }
};

const handleCardImageCtaClick = (
  section: string,
  text: string,
  url: string
) => {
  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    section.toLowerCase(),
    text.toLowerCase(),
    "hover card"
  );
  if (process.client) {
    navigateTo(url, {
      open: {
        target: "_self",
      },
    });
  }
};

const handleCollapseEvent = (action: string, section: string, text: string) => {
  analyticsComposable.trackCollapseEvent(
    "onclick",
    action,
    "click",
    "main content",
    section.toLowerCase(),
    text.toLowerCase(),
    "accordion-standard"
  );
};

const totalPages = computed(() => {
  const maxPageNumber = Math.ceil(rankingsItemsList?.value?.length! / perPage);
  return maxPageNumber;
});

const showPreviousSlide = () => {
  let slideNumber = currentSlide.value - 1;
  if (slideNumber < 1) {
    slideNumber = 1;
  }
  updateSlide(slideNumber);
};

const showNextSlide = () => {
  let slideNumber = currentSlide.value + 1;
  if (slideNumber > totalPages.value) {
    slideNumber = totalPages.value;
  }
  updateSlide(slideNumber);
};

const handleIndicatorClick = (slideNumber: number) => {
  updateSlide(slideNumber);
};

const updateSlide = (slideNumber: number) => {
  currentSlide.value = slideNumber;
  const lowIndex = slideNumber * perPage - perPage;
  const highIndex = slideNumber * perPage;
  paginatedCards.value = rankingsItemsList?.value?.slice(lowIndex, highIndex);
};

const isLastIndex = (itemCount: number, index: number) => {
  return index === itemCount - 1;
};

onMounted(() => {
  const data = $page?.aboutRankings.leadingRankings;
  if (data) {
    rankingsItemsList.value = data.filter(
      (item) => item !== null
    ) as ParagraphStatApollo[];
  }
  updateSlide(1);
});
</script>

<style lang="scss" scoped>
:deep(.global-rankings-section .section-bg) {
  background-color: var(--rds-dark-3);
}

.title-slot {
  padding: 4px 8px;
}

.asu-online-good-bg {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
}

.section-accolades-bg {
  background-position: center top;
}

.hr-line {
  width: 68px;
  height: 8px;
}

.carousel-control {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid var(--rds-light-4);
  background: var(--rds-light-3);
  cursor: pointer;
}
.disable {
  opacity: 0.5;
  cursor: auto;
}
.carousel-indicator {
  display: inline-block;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: var(--rds-light-4);
  cursor: pointer;
  border: 0;
  &:focus {
    outline: 1px solid var(--rds-dark-3);
  }
}
.carousel-indicator.active {
  background-color: var(--rds-dark-3);
}
.slide-fade-enter-active {
  transition: all 0.5s ease-in-out;
}
.slide-fade-leave-active {
  transition: all 0.5s;
}
.slide-fade-enter {
  transform: translateX(20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

.good-shool-badge {
  width: 100%;
  max-width: fit-content;
}
.highlight-text {
  display: inline;
  padding: 4px 0;
  -webkit-box-decoration-break: clone;
  -ms-box-decoration-break: clone;
  -o-box-decoration-break: clone;
  box-decoration-break: clone;
  box-shadow: 8px 0 0 var(--rds-secondary), -8px 0 0 var(--rds-secondary);
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .bg-repeat-50 {
    background-size: auto 50%;
    background-repeat: repeat;
  }
}
</style>
